export const convertToSVG = (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const base64 = (e.target?.result as string).split(",")[1];

                const svg = `
<svg xmlns="http://www.w3.org/2000/svg"
     xmlns:xlink="http://www.w3.org/1999/xlink"
     viewBox="0 0 1920 1080"
     preserveAspectRatio="xMidYMid meet">

    <image 
        width="1920" 
        height="1080" 
        x="0" 
        y="0"
        xlink:href="data:${file.type};base64,${base64}"
    />
</svg>`;

                const blob = new Blob([svg], {
                    type: "image/svg+xml",
                });

                resolve(
                    new File([blob], file.name.replace(/\..+$/, ".svg"), {
                        type: "image/svg+xml",
                    }),
                );
            } catch (err) {
                reject(err);
            }
        };

        reader.onerror = () => reject(new Error("Failed to read file"));

        reader.readAsDataURL(file);
    });
};
